import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

var parseHash = function parseHash(hash) {
  return hash.split('&').reduce(function (acc, item) {
    var currentAcc = acc;
    var parts = item.split('=');

    var _parts = _slicedToArray(parts, 2);

    currentAcc[parts[0]] = _parts[1];
    return currentAcc;
  }, {});
};

export default parseHash;